import React from 'react';

import routes from 'sitewide-js/core_pre_webpack/routes';
import ExportFormatModal from 'js/export_format/ExportFormatModal';

interface Props {
  apiPath: string;
  recordCount: number;
}

const MentionsExportModal: React.FC<Props> = ({ apiPath, recordCount }) => (
  <ExportFormatModal
    apiPath={apiPath}
    breadcrumbLabel="Citations and Mentions"
    csvDescription="Open in Excel, Google Sheets, or Numbers. One row per mention."
    recordCount={recordCount}
    recordNoun="mention"
    calloutTitle="Academia continuously searches public records for papers that cite your work."
    calloutDesc="As a Premium member you get every new mention as it is found, plus the surrounding citation context."
    resolveDownloadHref={(id) =>
      routes.download_mentions_export_url({ mentions_export_id: id })
    }
  />
);

export default MentionsExportModal;
